import { useState, useEffect } from "react";
import ListingCard from "./ListingCard";

const API_URL = process.env.REACT_APP_API_URL || process.env.VITE_API_URL || "http://localhost:8080";

export default function ListingSlider() {
  const [listings, setListings] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchListings = async () => {
      try {
        const response = await fetch(`${API_URL}/api/listings`, {
          headers: {
            "X-MCP-Protocol": "1.0",
          },
        });
        if (response.ok) {
          const data = await response.json();
          setListings(data.listings || []);
        }
      } catch (error) {
        console.error("Erro ao buscar anúncios:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchListings();
  }, []);

  useEffect(() => {
    if (listings.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % listings.length);
      }, 5000); // Muda a cada 5 segundos
      return () => clearInterval(interval);
    }
  }, [listings.length]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "3rem 0" }}>
        <p style={{ color: "var(--text-secondary)" }}>Carregando anúncios...</p>
      </div>
    );
  }

  if (listings.length === 0) {
    return null;
  }

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + listings.length) % listings.length);
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % listings.length);
  };

  return (
    <div className="listing-slider-container">
      <div className="listing-slider">
        <button
          className="slider-button slider-button-prev"
          onClick={goToPrevious}
          aria-label="Anterior"
        >
          ‹
        </button>
        
        <div className="slider-content">
          {listings.map((listing, index) => (
            <div
              key={listing.id || index}
              className={`slider-slide ${index === currentIndex ? "active" : ""}`}
            >
              <ListingCard listing={listing} />
            </div>
          ))}
        </div>

        <button
          className="slider-button slider-button-next"
          onClick={goToNext}
          aria-label="Próximo"
        >
          ›
        </button>
      </div>

      <div className="slider-dots">
        {listings.map((_, index) => (
          <button
            key={index}
            className={`slider-dot ${index === currentIndex ? "active" : ""}`}
            onClick={() => goToSlide(index)}
            aria-label={`Ir para slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
